require('../../Icon/Icon.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_S.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_M.scss');
require('../../Icon/_Play/_Size/Icon_Play_Size_L.scss');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Button = require('app/www/components/blocks/Button/Button');
const ButtonWrapper = require('app/www/components/blocks/ButtonWrapper/ButtonWrapper');
const Global = require('app/www/components/blocks/Global/Global');
const Metrika = require('app/www/libs/client/metrika');
const Ua = require('app/www/components/blocks/Ua/Ua');

class Button_WatchEpisode extends React.PureComponent {
    constructor(props) {
        super(props);

        this._showButton = Global.isRussia && !Ua.isOldOpera && !Ua.isOldIE;

        this._onClick = this._onClick.bind(this);
    }

    componentDidMount() {
        if (this._showButton) {
            const {
                programId,
                programType,
                programTitle,
            } = this.props;

            Metrika.trackParams('VOD', {
                param: 'button_show',
                programTitle,
                programType: programType.alias,
                programId,
            });
        }
    }

    render() {
        if (!this._showButton) {
            return null;
        }

        const {children} = this.props;

        const buttonWrapperProps = {
            mods: {
                active: true,
            },
        };

        const buttonProps = Object.assign({}, this.props, {
            onClick: this._onClick,
            children: children || this._title,
        });

        return (
            <ButtonWrapper {...buttonWrapperProps}>
                <Button ref={ref => (this.button = ref)} {...buttonProps} />
            </ButtonWrapper>
        );
    }

    get _title() {
        const {i18n, programType} = this.props;
        const {alias, isFilm, isSerial} = programType;

        const i18nKey = (isFilm || isSerial) ? alias : 'other';

        return i18n.get(`button.watch-episodes.${i18nKey}`);
    }

    /**
     * Обработчик нажатия на кнопку
     * @private
     */
    _onClick(evt) {
        const {
            programId,
            programType,
            programTitle,
            onClick,
        } = this.props;

        evt.preventDefault();
        onClick();

        Metrika.trackParams('VOD', {
            param: 'video_click',
            programTitle,
            programType: programType.alias,
            programId,
            target: 'button',
        });
    }
}

Button_WatchEpisode.defaultProps = {
    onClick: () => {},
};

Button_WatchEpisode.propTypes = {
    onClick: PropTypes.func,
    mods: Button.propTypes.mods,
    programId: PropTypes.number.isRequired,
    programTitle: PropTypes.string.isRequired,
    programType: PropTypes.object.isRequired,
};

module.exports = withI18n(Button_WatchEpisode);
